/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import './styles.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { MetaInfos } from 'components/metaInfos'
import { useWindowSize } from 'hooks/useWindowSize'
import { Elina } from './elina'
import { Farije } from './farije'
import { Hazeta } from './hazeta'
import { Margarita } from './margarita'

let dataStandaloneRC = require('../../')
// TODO Set the correct article ID here
const ARTICLE_ID = '384820191036'
export function AppComponent() {
  const size = useWindowSize()
  return (
    <div className='index'>
      <Masthead articleId={ARTICLE_ID} />
      <ThemeSwitch />

      <header className='ui vertical  very fitted  segment'>
        <div className='ui container'>
          <div className='ui header'>
            <div className='ui text container'>
              <img src={require('images/cover.jpg')} />
            </div>
            <h1>
              «Frauen, habt Mut, das Zepter selbst in die Hand zu nehmen!»
            </h1>
            <h2>
              Was bedeutet es, wenn man in der Schweiz zu Hause ist, aber kein
              Mitspracherecht hat? Vier eingebürgerte Frauen erzählen anlässlich
              des Internationalen Frauentages am 8. März.
            </h2>
          </div>
        </div>
      </header>

      <div className='ui vertical very fitted segment'>
        <div className='ui text container'>
          <MetaInfos
            authors={[
              'Aleksandra Hiltmann',
              'Urs Jaudas',
              'Daniel Ammann',
              'Sebastian Broschinski'
            ]}
            updated='8. März 2021'
          />
        </div>
      </div>
      <Elina
        size={size}
        colors={{ main: '#512a4f', sub: '#7A3F77', cover: '#EFECE0' }}
      />
      <Hazeta
        size={size}
        colors={{ main: '#512a4f', sub: '#7A3F77', cover: '#EFECE0' }}
      />
      <Margarita
        size={size}
        colors={{ main: '#512a4f', sub: '#7A3F77', cover: '#EFECE0' }}
      />
      <Farije
        size={size}
        colors={{ main: '#512a4f', sub: '#7A3F77', cover: '#EFECE0' }}
      />

      <Footer
        hidePortfolioTeaser
        articleId={ARTICLE_ID}
        questions={[
          'Wie unterhaltsam war der Beitrag?',
          'Wie gefällt Ihnen die Gestaltung?'
        ]}
        credits={[
          ['Text und Interviews', 'Aleksandra Hiltmann'],
          ['Fotos', 'Urs Jaudas, Daniel Ammann'],
          ['Umsetzung', 'Sebastian Broschinski']
        ]}
      />
    </div>
  )
}
